/**
 * A storage tab's title (UI/UX fix round A, review U27). On an account with a hierarchical namespace one location can be
 * open twice — in the Data Lake view and in the Blob view — so those titles end in " · Data Lake" / " · Blob"; every
 * other tab keeps the plain `storageTabTitle`.
 */
import type { StorageResourceRef } from '../../../../types/azureStorage';
import { getStorageAccountInfoSnapshot } from '../../../database-objects/store/storageAccountInfoStore';
import { storageTabTitle } from './storagePaths';

export function storageViewTabTitle(connectionId: string, ref: StorageResourceRef): string {
  const title = storageTabTitle(ref);
  if (ref.kind === 'hnsPath') return `${title} · Data Lake`;
  const blobView = ref.kind === 'container' || ref.kind === 'blobPrefix' || ref.kind === 'blob';
  return blobView && getStorageAccountInfoSnapshot(connectionId)?.hns === 'yes' ? `${title} · Blob` : title;
}
